import Clipboard from 'clipboard'
import { Toast } from 'mint-ui'

function clipboardSuccess() {
  Toast({ message: '复制成功', position: 'center', duration: 2000 })
}

function clipboardError() {
  Toast({ message: '复制失败', position: 'center', duration: 2000 })
}

export default function handleClipboard(text, event) {
  const clipboard = new Clipboard(event.target, {
    text: () => text
  })
  clipboard.on('success', () => {
    console.log(333)
    clipboardSuccess()
    clipboard.destroy()
  })
  clipboard.on('error', () => {
    console.log(444)
    clipboardError()
    clipboard.destroy()
  })
  clipboard.onClick(event)
}

/** 原生复制 **/
export function copyTextToClipboard(text) {
  var e = document.createElement('textarea')
  e.style.position = 'fixed'
  e.style.top = 0
  e.style.left = 0
  e.style.width = '2em'
  var message = '复制'
  e.style.height = '2em'
  e.style.padding = 0
  e.style.border = 'none'
  e.style.outline = 'none'
  e.style.boxShadow = 'none'
  e.style.background = 'transparent'
  e.style.opacity = '0'
  e.style.pointerEvents = 'none'
  e.value = text

  document.body.appendChild(e)
  e.select()

  try {
    var msg = document.execCommand('copy') ? '成功' : '失败'
    e.style.display = 'none'
    console.log('复制内容 ' + msg)
    message = message + msg
    Toast({ message, position: 'bottom' })
  } catch (err) {
    console.log('不能使用这种方法复制内容')
  }

  document.body.removeChild(e)
}
